import { render, staticRenderFns } from "./WorkgroupSettings.vue?vue&type=template&id=c1a107ec&scoped=true"
import script from "./WorkgroupSettings.vue?vue&type=script&lang=js"
export * from "./WorkgroupSettings.vue?vue&type=script&lang=js"
import style0 from "./WorkgroupSettings.vue?vue&type=style&index=0&id=c1a107ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1a107ec",
  null
  
)

export default component.exports